import script from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./OrderConfirm.vue?vue&type=style&index=0&id=c51d0eae&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/Application deploy/prod-fe-cn-social-media-wph-h5-deployment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c51d0eae"]])

export default __exports__